import type { Intake } from "./intake"
import { stepItems, type Step } from "./steps"
import { extrasFor } from "./step-extras"

/**
 * Page sequence for the step pager UI. The pager walks one page at a time;
 * pages that would be empty for a step (no decisions, no scripts, no items
 * for this intake) are skipped so users never land on a blank screen.
 */
export const STEP_PAGE_KINDS = ["overview", "do", "decisions", "scripts", "wrap-up"] as const
export type StepPageKind = (typeof STEP_PAGE_KINDS)[number]

export const STEP_PAGE_TITLES: Record<StepPageKind, string> = {
  overview: "Overview",
  do: "Do this",
  decisions: "Decisions",
  scripts: "Scripts and templates",
  "wrap-up": "Wrap up",
}

export function buildStepPages(step: Step, intake: Intake): StepPageKind[] {
  const extras = extrasFor(step.id, intake)
  const pages: StepPageKind[] = ["overview"]
  if (stepItems(step, intake).length > 0) pages.push("do")
  if (extras && extras.decisions.length > 0) pages.push("decisions")
  if (extras && extras.scripts.length > 0) pages.push("scripts")
  pages.push("wrap-up")
  return pages
}
